import { get } from 'lodash'
import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import { ChainingAdditionalInformation } from '../classes/ChainingAdditionalInformation'
import { ChainingAdditionalInformationDto } from '../types/ChainingAdditionalInformationDto'

export class ChainingAdditionalInformationAdapter implements ApiDataAdapter<ChainingAdditionalInformation> {
    public createClass(apiData: ChainingAdditionalInformationDto): ChainingAdditionalInformation {
        return new ChainingAdditionalInformation({
            id: get(apiData, 'id'),
            objectClass: get(apiData, 'object_class'),
            objectId: get(apiData, 'object_id'),
            isDefaultChainingSaved: get(apiData, 'is_default_chaining_saved'),
        })
    }
}
